import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import img from '../assets/others/11102051.jpg'
import checkicon from '../assets/icons/check-circle-bl.svg'
import img3 from '../assets/others/11102052.jpg'
import { Helmet } from 'react-helmet'


const Freetraining = () => {
  return (
    <div>
      <Helmet>
      <title>1-Day Free VLSI Training | Takshila VLSI</title>
      <meta name="description" content="Join Takshila VLSI&#039;s 1-day free training session in VLSI design. Learn from experts and Check out opportunities in semiconductor industry." />
      <link rel="canonical" href="https://www.takshila-vlsi.com/events/1-day-free-vlsi-training/" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="1-Day Free VLSI Training | Takshila VLSI" />
      <meta property="og:description" content="Join Takshila VLSI&#039;s 1-day free training session in VLSI design. Learn from experts and Check out opportunities in semiconductor industry." />
      <meta property="og:url" content="https://www.takshila-vlsi.com/events/1-day-free-vlsi-training/" />
      <meta property="og:site_name" content="Takshila VLSI" />
      <meta property="article:modified_time" content="2024-11-28T12:41:32+00:00" />
      <meta property="og:image" content="https://www.takshila-vlsi.com/wp-content/uploads/2019/09/shutterstock_247186180_Workshop.jpg" />
      <meta property="og:image:width" content="1000" />
      <meta property="og:image:height" content="680" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
       <Header/>
       <main>
       <section className='section-banner pg-banner mb-5'>
            <div class="container text-center">
                          <div class="row justify-content-around ">
                              <div class="col-md p-5">
                                <div class="pg-title-sec pl-r-12">
                                    <h1 className='pg-title pb-3'>1-Day Free VLSI Training</h1>
                                    <p className='pg-title-desc'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.
                                    </p>
                                </div>
                              </div>
                          </div>
                          <div className='row justify-content-center'>
                          <div class="col-lg img-radius">
                            <img src={img} alt=''/>
                          </div>
                          </div>
            </div>
          </section>
          <section className='p-lg-5'>
            <div class="container ">
                <div class="row">
                
                    <div class="col-lg-12">
                    <div className='bg-12 p-lg-5 p-3 radius-1'>
                        <div class="col-lg-12">
                        <div class="txt-3 mb-3">Register For our 1-Day Free VLSI Training</div>
                        <p> We provide 1-Day Free VLSI Training with specific tools and good classroom practice experience. This will help ensure that the students have full experience of what the course offers. The class categories are divided according to the course titles. Specific trainers assigned to each category. This ensures that students enjoy first-hand experience of what the class section feels like.
                        </p>
                        <p>We also offer an overview of our VLSI design courses and you will enjoy the following useful benefits during demo session.
                        </p>
                        </div>
                
                    <div class="col-lg-12 pt-3">
                        <div class="icon-left-bx d-flex mb-2">
                            <div class="icn-img"> 
                                <img src={checkicon} alt=''/></div>
                                <div class="icn-heading">Prepare and build students in learning new techniques while adapting to changes quickly.</div>
                            </div>
                            <div class="icon-left-bx d-flex mb-2">
                            <div class="icn-img"> 
                                <img src={checkicon} alt=''/></div>
                                <div class="icn-heading">Provide a solid stream of productive and employable engineers while creating a talent pool for the Electronics and Semiconductor industry.</div>
                            </div>
                            <div class="icon-left-bx d-flex mb-2">
                            <div class="icn-img"> 
                                <img src={checkicon} alt=''/></div>
                                <div class="icn-heading">Provide an all-inclusive methodology to skill development. Our lab sessions, in-class sessions, and live projects are crafted in such a way for you to gain industry experience.</div>
                            </div>
                            
                    </div>  
                    </div>  
                    </div> 
                </div>
                </div>
            </section>
            <section className='p-lg-5 pt-4'>
            <div class="container text-center">
              <div class="row">
                <div class="col-lg">
                <h2 class="ws-section_heading mb-3 txt-3"><span class="font-thin">Navigate your path to</span><br/> getting the dream VLSI job</h2>
                <p class="ws-section_sub-heading text-lg">Fill out the form below and avail free access to best recruiters leading the semiconductor industry</p>
                </div>
              </div>
              </div>
            </section>
            <section className='connect-section ws-section pb-5'>
          <div className='container'>
          <div class="row">
                <div class="col-lg img-radius">
                <img src={img3} alt=''/>
                </div>
                <div class="col-lg ml--10 mt-5">
                  <div className='ctn-frm'>
                <h2 class="mb-3">Let's Connect</h2>
                <iframe
                                    aria-label='Register Now'
                                    width="100%"
                                    height="850"
                                    src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                                    frameborder="0" 
                                    title='Register Now'
                                   
                                />
                </div>
                </div>
                
            </div>
            </div>
          </section>
       </main>
       <Enrollaction/>
        <Partnersec/> 
        <Footer/>
    </div>
  )
}

export default Freetraining